import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Fab, Tooltip, Zoom, Typography } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import CloseIcon from '@mui/icons-material/Close';

const FloatingCTA = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [pulse, setPulse] = useState(true);

  // Aparece después de 3 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!dismissed) setVisible(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, [dismissed]);

  // Pulso se detiene tras 5 segundos
  useEffect(() => {
    const timer = setTimeout(() => setPulse(false), 8000);
    return () => clearTimeout(timer);
  }, []);

  if (dismissed) return null;

  return (
    <Zoom in={visible}>
      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: 24, md: 36 },
          right: { xs: 20, md: 36 },
          zIndex: 1300,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: 1,
        }}
      >
        {/* Etiqueta de texto */}
        <Box
          sx={{
            backgroundColor: '#2B2B6B',
            color: 'white',
            px: 2,
            py: 0.8,
            borderRadius: '12px 12px 4px 12px',
            boxShadow: '0 4px 20px rgba(43,43,107,0.35)',
            mb: 0.5,
            maxWidth: 200,
          }}
        >
          <Typography sx={{ fontSize: '0.82rem', fontWeight: 600, lineHeight: 1.3 }}>
            Ready to begin your process?
          </Typography>
        </Box>

        {/* Botón principal + cerrar */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Botón X para cerrar */}
          <Tooltip title="Cerrar" placement="top">
            <Fab
              size="small"
              onClick={() => setDismissed(true)}
              sx={{
                width: 32,
                height: 32,
                minHeight: 32,
                backgroundColor: 'white',
                color: '#999',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                '&:hover': { backgroundColor: '#f5f5f5', color: '#E31E24' },
              }}
            >
              <CloseIcon sx={{ fontSize: 16 }} />
            </Fab>
          </Tooltip>

          {/* Botón principal */}
          <Tooltip title="Inicia tu proceso de admisión" placement="left">
            <Fab
              variant="extended"
              onClick={() => navigate('about-us/admissions')}
              sx={{
                backgroundColor: '#E31E24',
                color: 'white',
                fontWeight: 700,
                fontSize: '0.9rem',
                px: 2.5,
                gap: 1,
                boxShadow: '0 6px 24px rgba(227,30,36,0.45)',
                textTransform: 'none',
                letterSpacing: '0.3px',
                '@keyframes pulse': {
                  '0%': { boxShadow: '0 6px 24px rgba(227,30,36,0.45)' },
                  '50%': { boxShadow: '0 6px 36px rgba(227,30,36,0.75), 0 0 0 8px rgba(227,30,36,0.15)' },
                  '100%': { boxShadow: '0 6px 24px rgba(227,30,36,0.45)' },
                },
                animation: pulse ? 'pulse 2s ease-in-out infinite' : 'none',
                '&:hover': {
                  backgroundColor: '#C41A1F',
                  transform: 'scale(1.04)',
                  animation: 'none',
                },
                transition: 'transform 0.2s ease, background-color 0.2s ease',
              }}
            >
              <SchoolIcon sx={{ fontSize: 20 }} />
              Apply here
            </Fab>
          </Tooltip>
        </Box>
      </Box>
    </Zoom>
  );
};

export default FloatingCTA;